<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="form_field_type_master_list" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Form Field Type</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12">
            </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Form Field Type</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">

                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <!-- <v-col cols="12" sm="12" md="12">
                    <v-text-field 
                      v-model="editedItem.fieldType" 
                      persistent-hint
                      :disabled="editedIndex != -1"
                      :hint="editedIndex==-1?'For example :: Admission Form, Student Profile, Faculty Profile':'For example :: Admission Form, Student Profile, Faculty Profile'"
                      :filled="editedIndex==-1?false:true"
                      label="Form Field Type"
                      :error="errorMsg.fieldType?true:false"
                      :error-messages="errorMsg.fieldType?'Required':''"
                    ></v-text-field>
                  </v-col> -->
                        <v-col cols="12" sm="12" md="12" v-if='editedIndex == -1'>
                          <v-autocomplete :items="field_type_super_master_list"
                            v-model="addedItem.field_type_super_master_list" label="Select Field Type"
                            :rules="[v => !!v || 'required']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if='editedIndex != -1'>
                          <v-text-field v-model="editedItem.fieldType" persistent-hint :disabled="editedIndex != -1"
                            :hint="editedIndex==-1?'For example ::Admission Form, Student Profile, Faculty Profile':'noneditable'"
                            label="Field Type" :rules="[v => !!v || 'required']"></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" >Form Field Type
                          <v-select dense
                            v-model="editedItem.fieldType"
                            :items="field_type_super_master_list"                            
                            item-value="id"
                            persistent-hint
                            
                            :hint="'For example :: Admission Form, Student Profile, Faculty Profile'"
                            
                            :error="errorMsg.fieldType?true:false"
                            :error-messages="errorMsg.fieldType?'Required':''"
                          ></v-select>
                        </v-col> -->
                        <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      valid: false,
      overlay: false,
      errorMsg:{
        fieldType:false,
      },
      field_type_super_master_list: null,
      // extraBreadcrumbItems: [
      //   { text: "Form Field Type Master", disabled: true, href: "" },

      // ],


      // breadcrumbClass: "breadcrumb-style2",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Form Field Type',align: 'left',sortable: false,value: 'fieldType',
        },
        {
          text: 'Is Editable',align: 'left',sortable: false,value: 'iseditable',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      form_field_type_master_list: [],
      editedIndex: -1,
      addedItem:{
        field_type_super_master_list:''
      },
      editedItem: {
        id: '',
        fieldType: '',
        iseditable: '',
        isactive:true 
      
      },
      defaultItem: {
        id: '',
        fieldType: '',
        iseditable: '',
        isactive:true 
        
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Form Field Type' : 'Edit Form Field Type'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      overlay (val) {
        val = () => {
          this.overlay = false
        };
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted(){
      this.onLoad()
     },
    methods: {
    //   initialize () {
        
    //   },
      onLoad(){
        this.overlay=true
      axios
      .post("/AdmissionMaster/formFieldType")
      .then(res => {
        if (res.data.msg == "200") {
          //window.alert(res.data.msg)
         
          if(this.load = true){
            this.overlay=false;
           this.form_field_type_master_list = res.data.form_field_type_master_list
          this.field_type_super_master_list=res.data.field_type_super_master_list
          }
        } else {
          window.console.log(res.data.msg)
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(()=>{ 
        'use strict';
        var overlay=false;
      });
      },
      editItem (item) {
        this.editedIndex = this.form_field_type_master_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      // deleteItem (item) {
      //   const index = this.form_field_type_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.form_field_type_master_list.splice(index, 1)
      // },

     showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) 
        {
          if(this.isValidated())
         {
          axios
          .post("/AdmissionMaster/editFormFieldType", this.editedItem)
          .then(res => {
            if (res.data.msg == "200") {
              //window.alert(res.data.msg)
              Object.assign(this.form_field_type_master_list[this.editedIndex], this.editedItem)
            }
            this.showSnackbar(
                  "#4caf50",
                  "Form Field Type Updated Successfully..."
                ); // show snackbar on success
          })
          .catch(error => {
            window.console.log(error);
          });
            this.close()
         }
        } 
        else 
        {
           axios
          .post("/AdmissionMaster/saveFormFieldType", this.addedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
            //window.alert(res.data.status.code)
            this.form_field_type_master_list.push(this.addedItem)
            this.showSnackbar("#4caf50", "Form Field Added Successfully!!!"); // show snackbar on success
            this.onLoad()
            }
            else if(res.data.status.code == "NA"){
                //window.alert(res.data.status.code)
                this.showSnackbar("#b71c1c", "Form Field Already Present!!!"); // show snackbar on error
            }
          })
          .catch(error => {
            window.console.log(error);
          });
          this.close()
        }
      }, //save()
      isValidated(){
      if(this.editedItem.fieldType)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.fieldType)
            {
              this.errorMsg.fieldType=true
            }
           
        return false;
      }  
     }, // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
.mytable /deep/ thead th {
      background: #0F2027;  /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2C5364, #203A43, #0F2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0F2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>